const EVENT_CATEGORY = 'store'
const EVENT_LABEL = 'header redirect'
const OLD_WEB_EVENT_NAME = 'Telecompra'
const WEB_EVENT_NAME = 'MO'

export function sendNotSupportedPostalCodeMetrics() {
  window.gtag('event', OLD_WEB_EVENT_NAME, {
    event_category: EVENT_CATEGORY,
    event_label: EVENT_LABEL,
  })
}

export function sendSupportedPostalCodeMetrics() {
  window.gtag('event', WEB_EVENT_NAME, {
    event_category: EVENT_CATEGORY,
    event_label: EVENT_LABEL,
  })
}
